import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { VaultCardUI } from "../atoms/VaultCard";
import VaultItem from "./VaultItem";
import { colors } from "../../../ui/colors";

type Props = {
    filteredCards: VaultCardUI[];
    unlocked: boolean;
    search: string;
    isVerified: (id: string) => boolean;
    handleVerify: (id: string) => void;
    buildSecretDetail: (card: VaultCardUI) => any;
    handleDeleteSecret: (id: string) => Promise<void>;
    handleUpdateSecret: (id: string, dto: any) => Promise<void>;
    remainingSeconds: number;
    isPreviewMode?: boolean;
};

const VaultList: React.FC<Props> = ({
    filteredCards,
    unlocked,
    search,
    isVerified,
    handleVerify,
    buildSecretDetail,
    handleDeleteSecret,
    handleUpdateSecret,
    remainingSeconds,
    isPreviewMode,
}) => {
    const theme = useTheme();
    const masked = "••••••••••••";

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                minHeight: "300px",
                flex: 1,
                overflowY: "auto",
                justifyContent: filteredCards.length === 0 ? "center" : "flex-start",
                alignItems: "center",
                textAlign: "center",
                bgcolor: filteredCards.length === 0 ? colors.lightGray.lighter : "transparent",
                p: 1,
                borderRadius: 3,
                "&::-webkit-scrollbar": {
                    width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.1)",
                    borderRadius: "10px",
                },
            }}
        >
            {filteredCards.length === 0 ? (
                <Typography sx={{ color: theme.palette.text.secondary, fontSize: 14 }}>
                    {search.trim() ? "No matches found" : "You don’t have any password entries"}
                </Typography>
            ) : (
                filteredCards.map((card) => {
                    const hs = card.highSecurity;
                    const passwordDisplay = !unlocked ? masked : hs ? (isVerified(card.id) ? card.password : masked) : card.password || masked;

                    return (
                        <VaultItem
                            key={card.id}
                            card={card}
                            unlocked={unlocked}
                            isVerified={isVerified(card.id)}
                            passwordDisplay={passwordDisplay}
                            secretDetail={buildSecretDetail(card)}
                            onDelete={handleDeleteSecret}
                            onUpdate={handleUpdateSecret}
                            onVerify={() => handleVerify(card.id)}
                            vaultRemainingSeconds={remainingSeconds}
                            isPreviewMode={isPreviewMode}
                        />
                    );
                })
            )}
        </Box>
    );
};

export default VaultList;
